import { Inject, Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from '../base.service';
import { TownModel } from 'src/app/shared/model/town.model';
import { IAppConfig } from '../Config/app-config.model';

@Injectable({
  providedIn: 'root'
})
export class PostalService extends BaseService {

  constructor(public _injector: Injector, @Inject('appconfig') private configParam: IAppConfig) {
    super(_injector);
  }

  getStateTowns(stateId: number): Observable<TownModel[]> {
    return this.Get<TownModel[]>(`${this.configParam.ApiConfig.POSTAL_API_ENDPOINT}Lookup/towns/byState/${stateId}`);
  }

  getTown(townId: string): Observable<TownModel> {
    const routeParam = 'Lookup/town/';
    return this.Get<TownModel>(`${this.configParam.ApiConfig.POSTAL_API_ENDPOINT}${routeParam}${townId}`);
  }
}
